import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountGroupService, ProjectionFilter } from '@galaxy/account-group';
import { switchMap, take } from 'rxjs/operators';
import { DeleteAccountDialogComponent } from '../manage_accounts/dialogs/delete-account-dialog.component';

@Component({
  template: '',
  standalone: false,
})
export class AccountDeleteComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private accountGroupService: AccountGroupService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.accountGroupService
      .get(this.route.snapshot.params.accountGroupId, new ProjectionFilter({ napData: true }))
      .pipe(
        switchMap((accountGroup) => {
          this.dialog.closeAll();
          const ref = this.dialog.open(DeleteAccountDialogComponent, { width: '620px', data: { accountGroup } });
          return ref.afterClosed();
        }),
        take(1),
      )
      .subscribe((deleted) => {
        if (deleted && this.shouldRedirectToManageAccounts()) {
          this.router.navigateByUrl('/manage-accounts');
        } else {
          this.router.navigate([{ outlets: { action: null } }]);
        }
      });
  }

  /**
   * Returns true if the url contains the final segment "redirect" false if it does not. This redirect segment indicates
   * that once the delete is complete, it should redirect to the manage accounts page.
   */
  private shouldRedirectToManageAccounts(): boolean {
    const segments = this.route.snapshot.url;
    return segments.length > 0 && segments[segments.length - 1].path === 'redirect';
  }
}
